import { SCOPES } from 'constants/roles';

export default [
  {
    label: 'label.instance',
    name: 'settings-instance',
    url: '/professional/settings/instance/',
    navigationIcon: 'far fa-industry',
    scope: SCOPES.INSTANCE_OWNER,
    pages: [
      {
        label: 'label.profile',
        navigationIcon: 'far fa-id-card-alt',
        name: 'instance-profile',
        type: 'section',
        url: '/professional/settings/instance/profile',
        scope: SCOPES.INSTANCE_OWNER,
        pages: [
          {
            label: 'label.instance_details',
            name: 'instance-profile-details',
            navigationIcon: '',
            url: '/professional/settings/instance/profile/details',
            scope: SCOPES.INSTANCE_OWNER,
          },
          {
            label: 'label.instance_logo',
            name: 'instance-profile-logo',
            navigationIcon: '',
            url: '/professional/settings/instance/profile/logo',
            scope: SCOPES.INSTANCE_OWNER,
          },
        ],
      },
      {
        label: 'label.subscriptions',
        navigationIcon: 'far fa-credit-card-front',
        name: 'instance-subscription',
        type: 'section',
        url: '/professional/settings/instance/subscriptions',
        scope: SCOPES.INSTANCE_OWNER,
        pages: [
          {
            label: 'label.purchases',
            name: 'instance-subscription-purchases',
            navigationIcon: '',
            url: '/professional/settings/instance/subscriptions/purchases',
            scope: SCOPES.INSTANCE_OWNER,
            type: 'parent',
          },
        ],
      },
      {
        label: 'label.settings',
        navigationIcon: 'far fa-sliders-v',
        name: 'instance-settings-sources',
        type: 'section',
        url: '/professional/settings/instance/settings/',
        scope: SCOPES.INSTANCE_OWNER,
        pages: [
          // {
          //   label: 'label.general_settings',
          //   name: 'instance-settings-status',
          //   navigationIcon: '',
          //   url: '/professional/settings/instance/settings/status',
          //   scope: SCOPES.INSTANCE_OWNER,
          // },
          {
            label: 'label.sources',
            name: 'instance-settings-sources',
            navigationIcon: '',
            url: '/professional/settings/instance/settings/sources',
            scope: SCOPES.INSTANCE_OWNER,
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/navigations/settings/navigation-settings-instance.js